import { Card, Row, Col, Statistic, Typography } from "antd";
import {
  AreaChartOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EnvironmentOutlined,
  AppstoreOutlined,
  BranchesOutlined,
} from "@ant-design/icons";
import type { AdjacentCropKPIs as KPIData } from "../../types/adjacent-crop";

const { Title } = Typography;

interface Props {
  data: KPIData;
  loading?: boolean;
  countryName?: string;
}

export const AdjacentCropKPIs = ({ data, loading, countryName }: Props) => {
  return (
    <Card loading={loading}>
      <Title level={4}>
        {countryName
          ? `Cultivos Adyacentes - ${countryName}`
          : "Cultivos Adyacentes"}
      </Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Card>
            <Statistic
              title="Total Cultivos"
              value={data.total_adjacent_crops}
              prefix={<AreaChartOutlined />}
              valueStyle={{ color: "#1890ff" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Card>
            <Statistic
              title="Cultivos Abiertos"
              value={data.open_adjacent_crops}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: "#52c41a" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Card>
            <Statistic
              title="Cultivos Cerrados"
              value={data.closed_adjacent_crops}
              prefix={<CloseCircleOutlined />}
              valueStyle={{ color: "#ff4d4f" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Card>
            <Statistic
              title="Superficie Total"
              value={data.total_estimated_surface}
              precision={2}
              suffix="ha"
              prefix={<EnvironmentOutlined />}
              valueStyle={{ color: "#faad14" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Card>
            <Statistic
              title="Especies Únicas"
              value={data.unique_species}
              prefix={<AppstoreOutlined />}
              valueStyle={{ color: "#722ed1" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={4}>
          <Card>
            <Statistic
              title="Variedades Únicas"
              value={data.unique_varieties}
              prefix={<BranchesOutlined />}
              valueStyle={{ color: "#13c2c2" }}
            />
          </Card>
        </Col>
      </Row>
    </Card>
  );
};
